export const routes = {
    "/:taskId/followUpQuestionnaire": {
        title: "Manager Satisfaction Follow Up Questionnaire"
    }
};
